/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true, "allow": ["__insp"] }] */
define('AwaLabs.Inspectlet.Tracker', [
    'underscore',
    'Profile.Model'
], function InspectletTracker(
    _,
    ProfileModel
) {
    'use strict';

    return {
        trackShippingContext: function trackShippingContext(context) {
            if (context && !context.isPickup && !_.isUndefined(context.zipcode) && context.zipcode !== '') {
                if (context.showNoDeliveryMethods) {
                    if (!_.isUndefined(window.__insp)) {
                        window.__insp.push(['tagSession', {
                            zipcode: context.zipcode.toString(),
                            showCanDeliverToZipCode: context.showCanDeliverToZipCode.toString(),
                            showNoDeliveryMethods: context.showNoDeliveryMethods.toString()
                        }]);
                    }
                }
            }
        },
        trackTransaction: function trackTransaction(order) {
            if (!_.isUndefined(window.__insp)) {
                window.__insp.push(['tagSession', 'purchase']);
                window.__insp.push(['tagSession', {
                    checkoutStart: 'true',
                    checkoutEnd: 'true',
                    orderid: order.get('confirmationNumber')
                }]);
            }
        },
        trackPageview: function trackPageview(url) {
            var profile;
            if (url.indexOf('/opc') > -1) {
                profile = ProfileModel.getInstance();
                if (!_.isUndefined(window.__insp)) {
                    window.__insp.push(['identify', profile.get('internalid')]);
                    window.__insp.push(['tagSession', {
                        checkoutStart: 'true',
                        checkoutEnd: 'false'
                    }]);
                }
            }
        }
    };
});
